import { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import { getNewsBySlug } from "../../API/News/newsService";
import { CalendarClock } from "lucide-react";
import { Button } from "../../components/ui/button";

const NewsSinglePage = () => {
  const uploadUrl = process.env.REACT_APP_FILE_UPLOAD;
  const { id } = useParams();
  const [newsData, setNewsData] = useState<Record<string, any> | null>(null);

  useEffect(() => {
    const fetchData = async () => {
      if (id) {
        const data = await getNewsBySlug(id);

        setNewsData(data);
      }
    };

    if (id) {
      fetchData();
    }
  }, [id]);

  const extractPdfLink = (html: string) => {
    const urlMatch = html.match(/href=["']([^"']+\.pdf)["']/i);
    if (urlMatch) return urlMatch[1];

    const base64Match = html.match(
      /href=["'](data:application\/pdf;base64,[^"']+)["']/i
    );
    return base64Match ? base64Match[1] : null;
  };

  const removePdfLinks = (html: string) => {
    return html.replace(
      /<a[^>]+href=["'](data:application\/pdf;base64,[^"']+)["'][^>]*>.*?<\/a>/gi,
      ""
    );
  };

  return (
    <div className="mt-10">
      <div className="container mx-auto mt-20 mb-20 md:px-40 sm:px-40">
        <div className="mt-5">
          <h1 className="text-2xl font-bold text-black">
            {newsData?.news?.title || "Titre"}
          </h1>
          <div className="flex mt-2 space-x-3">
            <div className="text-primary">
              {newsData?.news?.date
                ? new Date(newsData.news.date).toLocaleDateString("fr-FR", {
                    month: "long",
                    day: "numeric",
                    year: "numeric",
                  })
                : new Date().toLocaleDateString("fr-FR")}
            </div>
          </div>

         </div>

        {/* News Image */}
        {newsData?.news?.image && (
          <div className="mt-5">
            <img src={`${uploadUrl}/news/${newsData.news.image}`} alt="" />
          </div>
        )}

        {/* News Description */}
        <div className="mt-10">
          {newsData?.news?.description && (
            <div
              dangerouslySetInnerHTML={{
                __html: removePdfLinks(newsData.news.description),
              }}
            />
          )}
        </div>

       
      </div>
    </div>
  );
};

export default NewsSinglePage;
